<template>
  <a-layout-content class="overflow-hidden">
    <div class="filter-panel">
      <a-row>
        <a-col :span="24" class="other-filter">
          <div class="mr-20">关键字:</div>
          <a-input class="mr-20" placeholder="关键字" style="width: 360px" v-model="keyword" />
          <div class="mr-20">检测机构:</div>
          <a-select class="mr-20" style="width: 80px" v-model="deptId" placeholder="检测机构">
              <a-select-option v-for="o in depts" :value="o.deptId" :key="o.deptId">{{ o.deptName }}</a-select-option>
          </a-select>
          <a-button class="mr-20 view-btn large" html-type="submit" @click="getList(true)">搜索</a-button>
          <a-button class="mr-20 view-btn large" html-type="submit" @click="reset">重置</a-button>
        </a-col>
      </a-row>
    </div>
    <a-divider></a-divider>
    <div class="flex-container filter-panel filter-panel2">
      <sub-title>数据列表</sub-title>
      <ul class="handle-list" style="margin: -11px 0">
        <li class="handle-item" @click="expandAll">
          <span v-if="this.expandedRowKeys.length == 0">
            <a-icon type="plus-square" theme="twoTone" two-tone-color="#52c41a" />
          </span>
          <span v-else>
            <a-icon type="minus-square" theme="twoTone" two-tone-color="#52c41a" />
          </span>&nbsp;
          <a href="javascript:;">{{ this.expandedRowKeys.length == 0 ? "展开" : "收起" }}</a>
        </li>
        <li class="handle-item" @click="openImple()" v-if="checkP()">
          <a-icon type="form" class="u_svg_color" />
          <a href="javascript:;">新增</a>
        </li>

        <li class="handle-item" @click="printImple()" v-if="checkP()">
          <a-icon type="form" class="u_svg_color" />
          <a href="javascript:;">打印</a>
        </li>

        <li class="handle-item" @click="exportData">
          <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" />&nbsp;
          <a href="javascript:;">导出</a>
        </li>
      </ul>
    </div>
    <a-divider></a-divider>
    <a-table :columns="columns" :dataSource="list" :rowKey="(record) => record.b_id" :loading="loading"
      :scroll="{ x: 1500, y: 800 }" v-if="list && list.length > 0" :pagination="pagination" @change="onPageChange"
      :row-selection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :expandedRowKeys.sync="expandedRowKeys" :rowClassName="rowClass" @expand="expandMe">
      <template slot="showTitle" slot-scope="text, record" ellipsis="...">
        <div :title="text" style="white-space: pre-wrap;">{{ text }}</div>
      </template>

      <template slot="countDown" slot-scope="text, record" ellipsis="...">
        <div :title="text" style="white-space: pre-wrap;">{{ countDown2(record) }}</div>
      </template>

      <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
      <table width="95%">
        <tr :class="rowClass(record)">
          <td width="23%">
            <span class="childCss">计划发（到）货时间：</span>
            <strong>
              {{ moment(record.b_plan_start).format("YYYY-MM-DD") }}
              ~{{ moment(record.b_plan_end).format("YYYY-MM-DD") }}
            </strong>
          </td>
          <td width="7%">
            <span class="childCss">数量：</span><strong>{{ record.b_num }}</strong>
          </td>
          <td width="25%">
            <span class="childCss">地点：</span><strong>{{ record.b_address }}</strong>
          </td>
          <td width="9%">
            <span class="childCss">联系人：</span><strong>{{ record.b_linkman }}</strong>
          </td>
          <td width="14%">
            <span class="childCss">联系电话：</span><strong>{{ record.b_linkphone }}</strong>
          </td>
          <td>
            <span class="childCss">备注说明：</span><strong>{{ record.b_remark }}</strong>
          </td>
        </tr>
      </table>
      </p>

      <template slot="showStatus" slot-scope="text, record">
        <div :title="text">{{ getStatus(record.b_status) }}</div>
      </template>

      <template slot="operation" slot-scope="text, record" v-if="checkP()">
        <span v-if="record.b_status == 0">
          <a @click="showImple(record)" href="javascript:;">编辑</a> |
          <a @click="cancelImple(record.b_id)" href="javascript:;">作废</a>
        </span>
        <span v-else>
          <a @click="showImple(record)" href="javascript:;">查看</a>
        </span>
      </template>
    </a-table>
    <!-- 列表表格 -->

    <!-- 批量新增 -->
    <a-modal centered title="编辑发/到货单" v-model="edit_visible1" :zIndex="2" width="95%" :maskClosable="false"
      @ok="save_handle1" @cancel="cancel_handle1">
      <div style="min-height:700px">
        <table width="100%" border="1">
          <tr align="center" height="40px;">
            <th>供应商名称</th>
            <th>报装编号</th>
            <th>工程项目名称</th>
            <th>物料名称</th>
            <th>型号规格</th>
            <th>数量</th>
            <th>计划发货日期</th>
            <th>计划到货日期</th>
            <th>计划发货数目</th>
            <th>联系人</th>
            <th>联系电话</th>
            <th>交货地点</th>
            <th>备注</th>
          </tr>
          <tr v-for="item in selectedRows" :key="item.id" style="height:40px">
            <td>{{ item.fullUnitName }}</td>
            <td>{{ item.bzNo }}</td>
            <td>{{ item.projectName }}</td>
            <td>{{ item.materialName }}</td>
            <td>{{ item.model }}</td>
            <td>{{ item.num }}</td>
            <td>
              <a-date-picker show-time format="YYYY-MM-DD" value-format="YYYY-MM-DD HH:mm:ss"
                v-model="item.plan_start" :disabled-date="disabledDate" />
            </td>
            <td>
              <a-date-picker show-time format="YYYY-MM-DD" value-format="YYYY-MM-DD HH:mm:ss" v-model="item.plan_end" :disabled-date="disabledDate" />
            </td>
            <td>
              <a-input-number :min="0" v-model="item.numx" />
            </td>
            <td>
              <a-input v-model="item.linkman" />
            </td>
            <td>
              <a-input v-model="item.linkphone" />
            </td>
            <td>
              <a-input v-model="item.address" />
            </td>
            <td>
              <a-input v-model="item.remark" />
            </td>
          </tr>
        </table>
      </div>
    </a-modal>

    <!-- 编辑 -->
    <a-modal centered title="编辑发/到货单" v-model="edit_visible" :zIndex="2" width="95%" :maskClosable="false"
      @ok="save_handle">
      <table width="100%" border="1">
        <tr>
          <td width="50%">
            <a-form class="modal-form" :form="form" v-if="edit_visible">
              <span v-if="!invoice || !invoice.b_id">
                <a-form-item label="选择执行单" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                  <a-icon type="search" title="执行单" style="cursor:pointer;padding-left:15px" @click="openImple" />
                </a-form-item>
              </span>
              <a-form-item label="计划发货时间" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                <a-date-picker placeholder="计划发货时间" :rows="4" v-decorator="[
                  'plan_start',
                  {
                    initialValue: invoice && (invoice.b_plan_start ? moment(invoice.b_plan_start) : null),
                    rules: [{ required: true, message: '计划发货时间不能为空' }],
                  },
                ]" show-time format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" />
              </a-form-item>
              <a-form-item label="计划到货时间" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                <a-date-picker placeholder="计划到货时间" :rows="4" v-decorator="[
                  'plan_end',
                  {
                    initialValue: invoice && (invoice.b_plan_end ? moment(invoice.b_plan_end) : null),
                    rules: [{ required: true, message: '计划到货时间不能为空' }],
                  },
                ]" show-time format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" />
              </a-form-item>
              <a-form-item label="数量" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                <a-input-number :min="0" placeholder="数量" :rows="4" v-decorator="[
                  'num',
                  {
                    initialValue: invoice && invoice.b_num,
                    rules: [{ required: true, message: '数量不能为空' }],
                  },
                ]" />
              </a-form-item>
              <a-form-item label="地点" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                <a-input placeholder="地点" :rows="4" v-decorator="[
                  'address',
                  {
                    initialValue: invoice && invoice.b_address,
                    rules: [{ required: true, message: '地点不能为空' }],
                  },
                ]" />
              </a-form-item>
              <a-form-item label="联系人" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                <a-input placeholder="联系人" :rows="4" v-decorator="[
                  'linkman',
                  {
                    initialValue: invoice && invoice.b_linkman,
                    rules: [{ required: true, message: '联系人不能为空' }],
                  },
                ]" />
              </a-form-item>
              <a-form-item label="联系电话" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                <a-input placeholder="联系电话" :rows="4" v-decorator="[
                  'linkphone',
                  {
                    initialValue: invoice && invoice.b_linkphone,
                    rules: [{ required: true, message: '联系电话不能为空' }],
                  },
                ]" />
              </a-form-item>
              <a-form-item label="备注说明" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                <a-textarea placeholder="备注说明" :rows="4" v-decorator="[
                  'remark',
                  {
                    initialValue: invoice && invoice.b_remark,
                  },
                ]" />
              </a-form-item>
            </a-form>
          </td>
          <td>
            <span v-if="selectedRowsx && selectedRowsx.length > 0">
              <a-form class="modal-form" v-if="edit_visible">
                <a-form-item label="供应商名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                  <a-input disabled :rows="4" v-model="selectedRowsx[0].fullUnitName" />
                </a-form-item>
                <a-form-item label="报装编号" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                  <a-input disabled :rows="4" v-model="selectedRowsx[0].bzNo" />
                </a-form-item>
                <a-form-item label="工程项目名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                  <a-input disabled :rows="4" v-model="selectedRowsx[0].projectName" />
                </a-form-item>
                <a-form-item label="物料名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                  <a-input disabled :rows="4" v-model="selectedRowsx[0].materialName" />
                </a-form-item>
                <a-form-item label="型号规格" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                  <a-textarea disabled :rows="4" v-model="selectedRowsx[0].model" />
                </a-form-item>
                <a-form-item label="数量" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                  <a-input disabled :rows="4" v-model="selectedRowsx[0].num" />
                </a-form-item>
                <a-form-item label="单位" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                  <a-input disabled :rows="4" v-model="selectedRowsx[0].unit" />
                </a-form-item>
              </a-form>
            </span>
          </td>
        </tr>
      </table>
    </a-modal>

    <!-- 选择执行单 -->
    <a-modal centered title="执行单" v-model="edit_visible2" :zIndex="2" width="1700px" :maskClosable="false"
      @ok="choose_handle">
      <div style="min-height:700px">
        <div class="filter-panel">
          <a-row>
            <a-col :span="24" class="other-filter">
              <div class="mr-20">关键字:</div>
              <a-input class="mr-20" placeholder="关键字" style="width: 360px" v-model="keyword2" />
              <div class="mr-20">物料名称:</div>
              <a-select class="mr-20" style="width: 240px" v-model="materialName" placeholder="物料名称">
                <a-select-option v-for="o in materials" :value="o" :key="o">{{ o }}</a-select-option>
              </a-select>
              <a-button class="mr-20 view-btn large" html-type="submit" @click="openImple">搜索</a-button>
              <a-button class="mr-20 view-btn large" html-type="submit" @click="reset2">重置</a-button>
            </a-col>
          </a-row>
        </div>
        <a-table :columns="columns2" :dataSource="list2" :rowKey="(record) => record.id" :loading="loading2"
          :scroll="{ x: 1500, y: 800 }" v-if="list2 && list2.length > 0" :pagination="pagination2"
          @change="onPageChange2"
          :row-selection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">

          <template slot="chooseMe" slot-scope="text,record">
            <div><input type="radio" /></div>
          </template>
          <template slot="showTitle" slot-scope="text, record" ellipsis="...">
            <div :title="text" style="white-space: pre-wrap;">{{ text }}</div>
          </template>
        </a-table>
      </div>
    </a-modal>

    <!-- 新增/编辑 -->

    <invoice-view ref="templateView" />
  </a-layout-content>
</template>
<script>
import SubTitle from "@/components/common/subTitle";
import { Divider, Modal } from "ant-design-vue";
import { get_check_list, save_invoice, save_invoices, cancel_invoice, list_imple, get_imple, exportData } from "@/api";
import { getUserInfo,materials,depts } from "@/plugins/common";
import moment from "moment";
import InvoiceView from "./InvoiceView";
export default {
  components: {
    SubTitle,
    ADivider: Divider,
    Modal,
    InvoiceView
  },
  data() {
    return {
      depts,
      deptId:"",
      materials,
      // 显示列
      columns: [/*{
                title: "id",
                width: 50,
                dataIndex: "b_id",
                key: "b_id",
                scopedSlots: { customRender: "showTitle" },
            }, */
        {
          title: "检测机构",
          width: 70,
          dataIndex: "deptName",
          key: "deptName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "供应商名称",
          width: 150,
          dataIndex: "a_fullUnitName",
          key: "a_fullUnitName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "报装编号",
          width: 100,
          dataIndex: "a_bzNo",
          key: "a_bzNo",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "工程项目名称",
          width: 300,
          dataIndex: "a_projectName",
          key: "a_projectName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "物料名称",
          width: 150,
          dataIndex: "a_materialName",
          key: "a_materialName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "型号规格",
          width: 150,
          dataIndex: "a_model",
          key: "a_model",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "数量",
          width: 70,
          dataIndex: "a_num",
          key: "a_num",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "单位",
          width: 70,
          dataIndex: "a_unit",
          key: "a_unit",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "状态",
          width: 70,
          dataIndex: "b_status",
          key: "b_status",
          scopedSlots: { customRender: "showStatus" },
        },
        {
          title: "记录人",
          width: 90,
          dataIndex: "a_userName",
          key: "a_userName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "打印计时（天）",
          width: 90,
          dataIndex: "b_checked_at",
          key: "count_down",
          scopedSlots: { customRender: "countDown" },
        },
        {
          title: "操作",
          key: "operation",
          width: 240,
          scopedSlots: { customRender: "operation" },
        }],
      // 部门集合
      list: [],
      pagination: {
        total: 0,
        current: 1,
        showTotal: (total) => {
          return `共 ${total} 条`;
        },
      },
      queryParams: {
        limit: 10,
        page: 0,
        searchCondition: {},
      },
      loading: false,
      keyword: "",

      invoice: {},
      edit_visible: false,
      form: this.$form.createForm(this),

      user: {},

      deling: false,

      edit_visible2: false,
      columns2: [
        /*{
          title: "id",
          width: 70,
          dataIndex: "id",
          key: "id",
        },*/
        {
          title: "供应商名称",
          width: 150,
          dataIndex: "fullUnitName",
          key: "fullUnitName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "报装编号",
          width: 100,
          dataIndex: "bzNo",
          key: "bzNo",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "工程项目名称",
          width: 150,
          dataIndex: "projectName",
          key: "projectName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "物料名称",
          width: 150,
          dataIndex: "materialName",
          key: "materialName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "型号规格",
          width: 150,
          dataIndex: "model",
          key: "model",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "数量",
          width: 100,
          dataIndex: "num",
          key: "num",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "单位",
          width: 80,
          dataIndex: "unit",
          key: "unit",
        },
        {
          title: "记录人",
          width: 100,
          dataIndex: "userName",
          key: "userName",
        }
      ],
      // 部门集合
      list2: [],
      pagination2: {
        total: 0,
        current: 1,
        showTotal: (total) => {
          return `共 ${total} 条`;
        },
      },

      queryParams2: {
        limit: 10,
        page: 0,
        searchCondition: {},
      },
      loading2: false,
      selectedRowKeys: [],
      selectedRows: [],
      materialName: "",
      keyword2: "",

      // 批量
      edit_visible1: false,

      selectedRowKeys: [],
      expandedRowKeys: [],

      selectedRowsx: []

    };
  },
  mounted() {
    this.user = getUserInfo();
    this.getList();
  },
  methods: {
    moment,
    checkP() {
      console.log(this.user);
      if (this.user.dept_id == 110 || this.user.role == 1) {
        return true;
      }
      return false;
    },
    getList(flag) {
      let self = this;
      if (this.loading) return;
      this.loading = true;
      if (flag == true) {
        this.pagination.current = 1;
      }
      this.queryParams.page = this.pagination.current - 1;

      if (this.keyword) {
        this.queryParams.searchCondition.keyword = this.keyword;
      } else {
        delete this.queryParams.searchCondition.keyword;
      }
      if (this.deptId) {
          this.queryParams.searchCondition.deptId = this.deptId;
      } else {
          delete this.queryParams.searchCondition.deptId;
      }

      get_check_list(this.queryParams)
        .then((res) => {
          console.log(res);
          self.list = res.list;
          self.pagination.total = res.total;
        })
        .finally((res) => {
          self.loading = false;
        });
    },
    onPageChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.queryParams.page = pagination.current - 1;
      this.getList();
    },

    reset() {
      // clear conditions
      this.keyword = "";
      this.deptId = "";
      this.pagination.current = 1;
      this.queryParams.page = 0;
      this.selectedRowKeys = [];
      this.getList();
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    expandAll() {
      if (this.expandedRowKeys.length == 0) {
        this.list.forEach((item, index) => {
          this.expandedRowKeys.push(item.b_id);
        });
      } else {
        this.expandedRowKeys = [];
      }
      // console.log(this.expandedRowKeys.length);
    },
    checkMe(status) {
      this.checkInvoice(status, this.selectedRowKeys);
    },
    checkOne(status, id) {
      this.checkInvoice(status, [id]);
    },
    rowClass(record) {
      // console.log(record.b_status);
      if (record.b_status == 1) {
        return "checkClass";
      } else if (record.b_status == 2) {
        return "coverClass";
      } else {
        return "";
      }
    },
    getStatus(b_status) {
      if (b_status == 1) {
        return "抽检";
      } else if (b_status == 2) {
        return "覆盖";
      } else {
        return "初始";
      }
    },
    expandMe(expanded, record) {
      console.log(expanded + "~" + record);
      console.log(this.expandedRowKeys);
      if (!expanded) {
        let idx = this.expandedRowKeys.indexOf(record.b_id);
        this.expandedRowKeys.splice(idx, 1);
      } else {
        this.expandedRowKeys.push(record.b_id);
      }
      console.log(this.expandedRowKeys);
    },

    showImple(invoice) {
      console.log(invoice);
      let self = this;
      this.form.resetFields();
      if (invoice) {
        this.invoice = invoice;
        get_imple(invoice.b_iid).then((res) => {
          console.log(res);
          self.selectedRowsx[0] = res;
          self.edit_visible = true;
        }).finally();
      } else {
        this.invoice = {};
        self.selectedRowKeys = [];
        self.selectedRowsx = [];
        this.edit_visible = true;
      }
    },

    save_handle1() {
      console.log("批量保存！");
      console.log(this.selectedRows);
      let params = [];
      this.selectedRows.forEach(item => {
        params.push({
          plan_start: item.plan_start.format("YYYY-MM-DD HH:mm:ss"),
          plan_end: item.plan_end.format("YYYY-MM-DD HH:mm:ss"),
          address: item.address,
          linkman: item.linkman,
          linkphone: item.linkphone,
          num: item.numx,
          remark: item.remark,
          iid: item.id,
          deptId:item.x_dept_id
        });
      });
      save_invoices(params).then((res) => {
        this.$message.success("保存成功！");
        this.cancel_handle1();
        this.getList();
        this.edit_visible = false;
      });
    },

    save_handle() {
      let self = this;
      console.log("保存！" + this.invoice);
      console.log(this.selectedRows[0]);
      if (this.invoice.b_status != 0) {
        this.edit_visible = false;
        return;
      }
      this.form.validateFields((err, values) => {
        console.log(err);
        if (!err) {
          let params = {
            id: self.invoice ? self.invoice.b_id : undefined,
            plan_start: values.plan_start.format("YYYY-MM-DD HH:mm:ss"),
            plan_end: values.plan_end.format("YYYY-MM-DD HH:mm:ss"),
            num: values.num,
            address: values.address,
            linkman: values.linkman,
            linkphone: values.linkphone,
            remark: values.remark,
            iid: self.invoice.b_iid ? self.invoice.b_iid : this.selectedRows[0].id
          };
          console.log(params);
          save_invoice(params).then((res) => {
            this.$message.success("保存成功！");
            this.getList();
            this.edit_visible = false;
          });
        }
      });
    },

    cancelImple(id) {
      // this.$message.warning("取消执行单：" + id);
      var self = this;
      Modal.confirm({
        title: "提示",
        content: "确定要作废吗？",
        centered: true,
        onOk() {
          if (self.deling) return;
          self.deling = true;
          cancel_invoice(id)
            .then((res) => {
              self.$message.success("操作成功");
              self.getList();
            })
            .finally((res) => {
              self.deling = false;
            });
        },
      });
    },

    openImple() {
      let self = this;
      // this.$message.warning("选择执行单！");
      console.log(this.queryParams2);
      if (this.loading2) return;
      this.loading2 = true;
      this.queryParams2.page = this.pagination2.current - 1;

      if (this.keyword2) {
        this.queryParams2.searchCondition.keyword = this.keyword2;
      } else {
        delete this.queryParams2.searchCondition.keyword;
      }
      if (this.materialName) {
        this.queryParams2.searchCondition.materialName = this.materialName;
      } else {
        delete this.queryParams2.searchCondition.materialName;
      }
      list_imple(this.queryParams2).then((res) => {
        self.list2 = res.list;
        self.pagination2.total = res.total;
        self.edit_visible2 = true;
      }).finally((res) => {
        self.loading2 = false;
      });
    },

    onPageChange2(pagination, filters, sorter) {
      this.pagination2 = pagination;
      this.queryParams2.page = pagination.current - 1;
      this.openImple();
    },

    choose_handle() {
      // this.$message.warning("选择执行单！" + this.selectedRows);
      if (this.selectedRows && this.selectedRows.length > 0) {
        this.edit_visible2 = false;
        this.edit_visible1 = true;
      } else {
        this.$message.warning("请选择执行单！");
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },

    cancel_handle1() {
      console.log("cancel_handle");
      this.keyword2 = "";
      this.materialName = "";
      this.selectedRowKeys = [],
        this.selectedRows = [],
        this.pagination2.current = 1;
      this.queryParams2.page = 0;
      this.edit_visible = false;
      this.edit_visible1 = false;
    },

    reset2() {
      console.log("reset2");
      // clear conditions
      this.keyword2 = "";
      this.materialName = "";
      this.selectedRowKeys = [],
        this.selectedRows = [],
        this.pagination2.current = 1;
      this.queryParams2.page = 0;
      this.openImple();
    },

    printImple() {
      if (!this.selectedRows || this.selectedRows.length == 0) {
        this.$message.warning("请选择要打印的数据！");
        return;
      }
      let flag = true;
      for (let idx in this.selectedRows) {
        let item = this.selectedRows[idx];
        // console.log(item);
        // if( (初始状态 || 抽检时间与当前时间相比 < 10) || (抽检不合格 && 整改不合格) )
        if (item.b_status == 0 || this.countDown(item.b_checked_at) < 10 || (item.b_check_result == 2 && item.b_rectify_result != 1)) {
          flag = false;
          break;
        }
      }
      if (!flag) {
        console.log(this.selectedRows);
        this.$message.warning("所选数据中存在未抽查（覆盖）的数据，或者抽检（覆盖）时间小于10天，或者抽检不合格且整改不合格！");
        return;
      }
      this.$refs["templateView"].open(this.selectedRows);
    },

    countDown(text) {
      let now = moment().format("YYYY-MM-DD");
      let date = moment(text).format("YYYY-MM-DD");
      let str = moment(now).diff(moment(date), 'days');
      return str;
    },

    countDown2(record) {
      let text = record.b_checked_at;
      let str = this.countDown(text);
      let b_check_result = record.b_check_result;
      let b_rectify_result = record.b_rectify_result;
      if( b_rectify_result == 2 ) {
        return "整改不合格";
      } else if(b_rectify_result == 1) {
        return "可打印";
      } else {
        if( b_check_result == 2 ) {
          return "整改中";
        }
      }
      return str >= 10?'可打印':str;
    },

    exportData() {
      if (this.loading) return;
      this.loading = true;
      this.queryParams.page = this.pagination.current - 1;

      if (this.keyword) {
        this.queryParams.searchCondition.keyword = this.keyword;
      } else {
        delete this.queryParams.searchCondition.keyword;
      }
      exportData(this.queryParams)
        .then((res) => {
          console.log(res);
          window.open(res);
        })
        .finally((res) => {
          this.loading = false;
        });
    },

    disabledDate(current) {
      // Can not select days before today and today
      // return current && current <= moment().startOf('day');
      return false;
    },

    //
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.other-filter {
  display: flex;
  height: 50px;
  align-items: center;

  .mr-20 {
    margin-right: 20px;
  }
}

.childCss {
  font-size: 14px;
}
</style>

<style>
.checkClass {
  color: orange;
}

.coverClass {
  color: blue;
}
</style>
